<template>
	<div class="salesOrder layui-layout layui-layout-admin" style="background:#fff;">
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				售后订单
			</div>
		</div>
		<div class="sxBox">
			<div class="layui-form f_row al_itm">
				<div class="layui-inline f_row al_itm">
					<div class="layui-input-inline" style="width: 100px;">
						<input type="text" class="layui-input" id="times1" readonly placeholder="开始日期">
					</div>
					<div class="layui-form-mid" style="margin: 0 10px;">-</div>
					<div class="layui-input-inline" style="width: 100px;">
						<input type="text" class="layui-input" id="times2" readonly placeholder="结束日期">
					</div>
				</div>
				<button type="button" class="layui-btn zt_color margin_l20" @click="onSearch">搜索</button>
				<button type="button" class="layui-btn zt_color margin_l20" @click="onReset">重置</button>
			</div>
		</div>
		<div v-show="showClass==1">
			<table class="layui-table align_center" id="orders" style="width:90%;margin-left:5%;">
				<colgroup>
					<col width="70">
					<col width="150">
					<col width="120">
					<col width="250">
					<col width="150">
					<col>
					<col>
					<col>
					<col>
					<col width="100">
				</colgroup>
				<thead>
					<tr>
						<th class="align_center">序号</th>
						<th class="align_center">订单编号</th>
						<th class="align_center">售后钢网数量</th>
						<th class="align_center">客户问题类别</th>
						<th class="align_center">客诉发起时间</th>
						<th class="align_center">附件</th>
						<th class="align_center">售后状态</th>
						<th class="align_center">客服审核结果</th>
						<th class="align_center">客户备注信息</th>
						<th class="align_center">订单操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item,i) in datas" :key="i">
						<td>{{i + 1}}</td>
						<td>{{item.order_num}}</td>
						<td>{{item.mesh_count}}</td>
						<td>{{item.sales_type_text}}</td>
						<td>{{item.time}}</td>
						<td>
							<img v-if="item.sales_imgs" class="accessory" :src="item.sales_imgs" @click="bigImgShow(item.sales_imgs)" />
							<span v-else>未上传</span>
						</td>
						<td style="color: rgb(255, 152, 0);">{{item.status_text}}</td>
						<td>{{item.sales_reason}}</td>
						<td>{{item.sales_content}}</td>
						<td>
							<button @click="showDetails(item.order_num)" type="button" class="layui-btn zt_color pointer">详情</button>
						</td>
					</tr>
					<tr v-if="datas.length == 0 || datas == []">
						<td style="padding: 5px 30px 0;text-align: center;line-height: 50px;" colspan="10">暂无数据</td>
					</tr>
				</tbody>
			</table>
			<div id="lypages" style="margin-left: 5%;"></div>
		</div>
		<div class="layer" v-if='big'></div>
		<div class="bigImg" v-if="big">
			<i class="layui-icon layui-icon-close-fill" style="color: rgba(0,0,0,0.5);font-size: 40px;" @click="bigImgHide"></i>
			<img :src="preview" style="width: 600px;" />
		</div>
	</div>
</template>

<script>
	export default {
		name: 'salesOrder',
		data() {
			return {
				dscModel: false,
				showClass: 1,
				tables: '',
				formss: '',
				nowTimes: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
				datas: [],
				pages: 1,
				limit: 10,
				count: 1,
				value: 0,
				value2: 0,
				search: 0,
				big: false,
				preview: ''
			}
		},
		created() {
			this.getData();
		},
		mounted() {
			let _this = this;
			layui.use(['table', 'form', 'laydate', 'layer'], () => {
				this.tables = layui.table;
				this.formss = layui.form;
				var laydate = layui.laydate;
				var laypage = layui.laypage;
				this.formss.render('select');
				laydate.render({
					elem: '#times1', //指定元素
					theme: '#4876FF',
					max: _this.nowTimes,
					done: function(value) {
						let time = new Date(value);
						let y = time.getFullYear();
						let m = time.getMonth() + 1;
						let d = time.getDate();
						let start = new Date(y + '/' + m + '/' + d);
						_this.value = new Date(start).getTime() / 1000;
					}
				});
				laydate.render({
					elem: '#times2', //指定元素
					theme: '#4876FF',
					max: _this.nowTimes,
					done: function(value) {
						let time = new Date(value);
						let y = time.getFullYear();
						let m = time.getMonth() + 1;
						let d = time.getDate();
						let end = new Date(y + '/' + m + '/' + d);
						_this.value2 = new Date(end).getTime() / 1000 + 86399;
					}
				});
			});
		},
		methods: {
			getData() {
				let _this = this;
				this.pages = 1;
				var obj = {
					token: _this.getCookie('token'),
					page: _this.pages,
					limit: _this.limit
				};
				if(this.search == 1) {
					obj.start_time = _this.value;
					obj.end_time = _this.value2;
				};
				layui.use(['laypage', 'layer'], () => {
					var laypage = layui.laypage;
					api.fSaleOrderList(obj).then((res) => {
						if(res.code == 1) {
							for(let i = 0; i < res.data.list.length; i++) {
								res.data.list[i].time = _this.getTimes2(res.data.list[i].c_post_sale_time);
							}
							_this.datas = res.data.list;
							_this.count = res.data.count;
						} else {
							_this.datas = []
						}
						laypage.render({
							elem: 'lypages',
							theme: '#4876FF',
							count: _this.count,
							limit: 10,
							jump: function(obj, first) {
								if(!first) {
									_this.pages = obj.curr;
									_this.getData2();
								}
							}
						});
					})
				})
			},
			getData2() {
				let _this = this;
				var obj = {
					token: _this.getCookie('token'),
					page: _this.pages,
					limit: _this.limit
				}
				if(this.search == 1) {
					obj.start_time = _this.value;
					obj.end_time = _this.value2;
				}
				api.fSaleOrderList(obj).then((res) => {
					if(res.code == 1) {
						for(let i = 0; i < res.data.list.length; i++) {
							res.data.list[i].time = _this.getTimes2(res.data.list[i].c_post_sale_time);
						}
						_this.datas = res.data.list;
					} else {
						_this.datas = [];
					}
				})
			},
			showDetails(num) {
				this.$router.replace({
					path: '/orderDetail',
					query: {
						id: num
					}
				})
			},
			bigImgShow(img) {
				this.preview = img;
				this.big = true;
			},
			bigImgHide() {
				this.big = false;
			},
			onSearch() {
				this.search = 1;
				this.pages = 1;
				this.count = 1;
				this.getData();
			},
			onReset() {
				this.search = 0;
				this.value = 0;
				this.value2 = 0;
				$('#times1').val('');
				$('#times2').val('');
				this.forms.render();
				this.getData();
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.accessory {
		width: 50px;
		height: 50px;
		cursor: pointer;
	}
	
	.jiaji {
		color: rgba(229, 28, 35, 1);
	}
	
	.salesOrder {
		font-family: SourceHanSansSC;
	}
	
	.sxBox {
		padding: 20px 5% 10px;
	}
	
	.layer {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.3);
		z-index: 10000;
	}
	
	.bigImg {
		width: 600px;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 10000;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.bigImg img {
		width: 600px;
	}
	
	.bigImg i {
		position: absolute;
		top: 0;
		right: 0;
		transform: translate(20px, -20px);
		z-index: 10001;
	}
</style>


// WEBPACK FOOTER //
// src/components/salesOrder.vue